import { currentTaxesSettingsSelector, selectReportingGroups } from './chunk-RO5AAHK3.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';
import cloneDeep from 'lodash/cloneDeep';
import difference from 'lodash/difference';
import get from 'lodash/get';
import has from 'lodash/has';
import isEqual from 'lodash/isEqual';
import isNaN from 'lodash/isNaN';
import orderBy from 'lodash/orderBy';
import setWith from 'lodash/setWith';
import uniq from 'lodash/uniq';
import uniqWith from 'lodash/uniqWith';

var MENU_TYPE_VERSIONS_FIELD = "menuTypeVersions";
var PREP_STATION_VERSIONS_FIELD = "prepStationVersions";
var filterDiffFunction = (diff, callback, returnLabel) => {
  var _a, _b;
  const field = diff.path[((_a = diff.path) == null ? void 0 : _a.length) - 1];
  const diffLength = diff.path.length;
  const newDiff = {
    field,
    label: (_b = returnLabel(field, diffLength)) != null ? _b : "",
    value: diff.rhs
  };
  return callback({ field, diffLength, newDiff });
};
var orderArray = (differences, fieldsOrder) => {
  const filteredFields = Object.entries(fieldsOrder).filter(([order]) => !isNaN(Number(order))).map((field) => [Number(field[0]), field[1]]);
  return orderBy(
    differences,
    (diff) => {
      var _a;
      return ((_a = filteredFields.find(([, field]) => field === diff.field)) == null ? void 0 : _a[0]) || 0;
    }
  );
};
var getMenuTypeArraysByAction = (diffArray, menuTypeId) => {
  const addedMenuTypesDiff = diffArray.filter(
    (diff) => diff.path.length === 2 && diff.path[0] === MENU_TYPE_VERSIONS_FIELD && diff.kind === "N" && (menuTypeId ? Number(diff.path[1]) === menuTypeId : true)
  );
  const removedMenuTypesDiff = diffArray.filter(
    (diff) => diff.path.length === 2 && diff.path[0] === MENU_TYPE_VERSIONS_FIELD && diff.kind === "D" && (menuTypeId ? Number(diff.path[1]) === menuTypeId : true)
  );
  const changedMenuTypeFieldsDiff = diffArray.filter(
    (diff) => diff.path.length === 3 && diff.path[0] === MENU_TYPE_VERSIONS_FIELD && diff.kind === "E" && (menuTypeId ? Number(diff.path[1]) === menuTypeId : true)
  );
  const arraysDiff = uniqWith(
    diffArray.filter(
      (diff) => diff.kind === "A" && (menuTypeId ? Number(diff.path[1]) === menuTypeId : true)
    ),
    (diff1, diff2) => isEqual(diff1.path, diff2.path)
  );
  return {
    arraysDiff,
    addedMenuTypesDiff,
    removedMenuTypesDiff,
    changedMenuTypeFieldsDiff
  };
};
var getPrepStationArraysByAction = (diffArray, prepStationId) => {
  const addedPrepStationsDiff = diffArray.filter(
    (diff) => diff.path.length === 2 && diff.path[0] === PREP_STATION_VERSIONS_FIELD && diff.kind === "N" && (prepStationId ? Number(diff.path[1]) === prepStationId : true)
  );
  const removedPrepStationsDiff = diffArray.filter(
    (diff) => diff.path.length === 2 && diff.path[0] === PREP_STATION_VERSIONS_FIELD && diff.kind === "D" && (prepStationId ? Number(diff.path[1]) === prepStationId : true)
  );
  const changedPrepStationsDiff = diffArray.filter(
    (diff) => diff.path.length === 3 && diff.path[0] === PREP_STATION_VERSIONS_FIELD && diff.kind === "E" && (prepStationId ? Number(diff.path[1]) === prepStationId : true)
  );
  return {
    addedPrepStationsDiff,
    removedPrepStationsDiff,
    changedPrepStationsDiff
  };
};
var getMenuTypeDiffPath = (path, menuTypeId) => {
  const diffPath = [...path];
  diffPath[1] = `${menuTypeId}`;
  return diffPath;
};
var isItemInMenuTypeCore = (itemId, menuTypeVersionId, state) => {
  const items = state.menu.selectedMode.currentMenu.items;
  return get(items[itemId], `menuTypeVersions.${menuTypeVersionId}`);
};
var getArrayEditIndex = (id, array) => array.findIndex((element) => element.action === "update" && element.id === id);
var getObjectNextSortPriority = (obj) => {
  return Object.keys(obj || {}).length + 1;
};
var getObjectSorted = (obj, elementId, sortPriority) => {
  const elementTarget = obj[elementId];
  if (!elementTarget) {
    return {
      elements: obj,
      hasChanges: false
    };
  }
  const newElements = cloneDeep(obj);
  const sortedElements = orderBy(
    Object.entries(obj),
    (element) => element[1].sortPriority
  ).map(
    (element) => isNaN(Number(element[0])) ? element[0] : Number(element[0])
  ).filter((_elementId) => _elementId !== elementId);
  sortedElements.splice(sortPriority - 1, 0, elementId);
  sortedElements.forEach((itemGroupId, index) => {
    newElements[itemGroupId].sortPriority = index + 1;
  });
  return {
    elements: newElements,
    hasChanges: true
  };
};
var removedSetFunction = (diff, menuTypeIdToApply, data) => {
  if (diff.kind !== "D") {
    return false;
  }
  const diffPath = getMenuTypeDiffPath(diff.path, menuTypeIdToApply);
  const removedElementPath = diffPath.join(".");
  const elementTarget = get(data, removedElementPath);
  if (!elementTarget) {
    return false;
  }
  const removedId = diffPath.splice(-1)[0];
  const removedParentPath = diffPath.join(".");
  const removedParent = get(data, removedParentPath);
  delete removedParent[removedId];
  setWith(data, removedParentPath, removedParent, Object);
  return true;
};
var addedObjectElementSetFunction = (diff, menuTypeIdToApply, data) => {
  const diffPathToApplyArray = getMenuTypeDiffPath(
    diff.path,
    menuTypeIdToApply
  );
  const diffPathToApply = diffPathToApplyArray.join(".");
  const newData = diff.rhs;
  setWith(data, diffPathToApply, newData, Object);
};
var changedElementSetFunction = (diff, menuTypeIdToApply, data) => {
  const diffPathToApplyArray = getMenuTypeDiffPath(
    diff.path,
    menuTypeIdToApply
  );
  const diffPathToApply = diffPathToApplyArray.join(".");
  const newData = diff.rhs;
  if (!has(data, diffPathToApply)) {
    return false;
  }
  setWith(data, diffPathToApply, newData, Object);
  return true;
};
var arrayElementSetFunction = (diff, menuTypeIdToApply, originalData, changedData) => {
  const diffPathToApplyArray = getMenuTypeDiffPath(
    diff.path,
    menuTypeIdToApply
  );
  const diffPathToApply = diffPathToApplyArray.join(".");
  const originalPath = diff.path.join(".");
  const originalArray = get(originalData, originalPath, []);
  const changedArray = get(changedData, originalPath, []);
  let targetArray = get(changedData, diffPathToApply, []);
  const changes = getArrayNumberChanges(originalArray, changedArray);
  changes.forEach((change) => {
    if (change.action === "add") {
      targetArray.push(change.id);
    } else {
      targetArray = targetArray.filter((item) => item !== change.id);
    }
  });
  setWith(changedData, diffPathToApply, uniq(targetArray), Object);
};
var getArrayNumberChanges = (originalIds, newIds) => {
  const removedIds = difference(originalIds, newIds);
  const addedIds = difference(newIds, originalIds);
  const changes = [];
  if (removedIds.length > 0) {
    removedIds.forEach((removedId) => {
      changes.push({
        action: "remove",
        id: removedId
      });
    });
  }
  if (addedIds.length > 0) {
    addedIds.forEach((addedId) => {
      changes.push({
        action: "add",
        id: addedId
      });
    });
  }
  return changes;
};
var getTaxesDiffArrayCore = (originalTaxes, changedTaxes, state) => {
  const taxes = currentTaxesSettingsSelector(state);
  const changes = getArrayNumberChanges(originalTaxes, changedTaxes);
  return changes.map((change) => {
    var _a;
    return __spreadProps(__spreadValues({}, change), {
      value: (_a = taxes[change.id]) == null ? void 0 : _a.name
    });
  });
};
var getReportingGroupsDiffArrayCore = (originalReportingGroups, changedReportingGroups, state) => {
  const reportingGroups = selectReportingGroups(state);
  const changes = getArrayNumberChanges(originalReportingGroups, changedReportingGroups);
  return changes.map((change) => {
    var _a;
    return __spreadProps(__spreadValues({}, change), {
      value: (_a = reportingGroups[change.id]) == null ? void 0 : _a.name
    });
  });
};
function getDiffArray(diffArray, returnLabel, enums, depth) {
  const changes = [];
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength, newDiff }) => {
        if (Array.isArray(enums) && Array.isArray(depth)) {
          enums.forEach((enumObj, index) => {
            if (diffLength !== depth[index]) {
              return;
            }
            if (!(field in enumObj)) {
              return;
            }
            changes.push(newDiff);
          });
        } else {
          if (diffLength !== depth) {
            return;
          }
          if (!(field in enums)) {
            return;
          }
          changes.push(newDiff);
        }
      },
      returnLabel
    )
  );
  return changes;
}

export { addedObjectElementSetFunction, arrayElementSetFunction, changedElementSetFunction, filterDiffFunction, getArrayEditIndex, getArrayNumberChanges, getDiffArray, getMenuTypeArraysByAction, getMenuTypeDiffPath, getObjectNextSortPriority, getObjectSorted, getPrepStationArraysByAction, getReportingGroupsDiffArrayCore, getTaxesDiffArrayCore, isItemInMenuTypeCore, orderArray, removedSetFunction };
